export enum StatusVariant {
  ERROR = 'error',
  SUCCESS = 'success',
}
